import { CaptchaProtection } from '~/services/captcha-protection'

export default (context, inject) => {
  let headers = {}
  if (process.server) {
    headers = context.req.headers
  }
  inject('captchaProtection', new CaptchaProtection(context.$cookies, context.$config, headers))
}
